export default __webpack_public_path__ + "static/media/04_HIGHLIGHT.7a8b425e.png";